var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4286 9.14286C31.4286 4.40899 27.591 0.571429 22.8571 0.571429H9.14286C4.40899 0.571429 0.571428 4.40899 0.571428 9.14286V22.8571C0.571428 27.591 4.40899 31.4286 9.14286 31.4286H22.8571C27.591 31.4286 31.4286 27.591 31.4286 22.8571V9.14286Z",
    fill: "#1C191E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4286 9.14286C31.4286 4.40899 27.591 0.571429 22.8571 0.571429H9.14286C4.40899 0.571429 0.571428 4.40899 0.571428 9.14286V22.8571C0.571428 27.591 4.40899 31.4286 9.14286 31.4286H22.8571C27.591 31.4286 31.4286 27.591 31.4286 22.8571V9.14286Z",
    stroke: "#37303E",
    strokeWidth: 1.14286
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 10.9997C9.33203 10.5576 9.50763 10.1337 9.82019 9.82116C10.1327 9.5086 10.5567 9.33301 10.9987 9.33301H20.9987C21.4407 9.33301 21.8646 9.5086 22.1772 9.82116C22.4898 10.1337 22.6654 10.5576 22.6654 10.9997V20.9997C22.6654 21.4417 22.4898 21.8656 22.1772 22.1782C21.8646 22.4907 21.4407 22.6663 20.9987 22.6663H10.9987C10.5567 22.6663 10.1327 22.4907 9.82019 22.1782C9.50763 21.8656 9.33203 21.4417 9.33203 20.9997V10.9997Z",
    stroke: "#9C3DE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.33301V22.6663",
    stroke: "#9C3DE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4987 14.333L16.832 15.9997L18.4987 17.6663",
    stroke: "#9C3DE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDark);
export default __webpack_public_path__ + "static/media/Button Dark.367ee011222eb33856800e768d89c4e2.svg";
export { ForwardRef as ReactComponent };